import React from 'react';
import RepresentativeRegisteredPage from '../../../../components/RepresentativeRegisteredPage';
import DocumentPage from '../../../../pages/DocumentPage';
import ListOfOrganisationsPage from '../../../../pages/ListOfOrganisationsPage';
import Mainpage from '../../../../pages/Mainpage';
import RegisterRepresentativePage from '../../../../pages/RegisterRepresentativePage';
import { RoutePathsType } from '../../../../types';
import { routerPath } from '../../../routerPath';

export const mainpageRoutes: RoutePathsType = [
  {
    path: routerPath.home,
    name: 'Главная страница',
    Component: <Mainpage />,
  },
  {
    path: routerPath.listOfOrganisations,
    name: 'Перечень организаций',
    Component: <ListOfOrganisationsPage />,
  },
  {
    path: routerPath.documentId,
    name: 'Федеральный перечень учебников',
    Component: <DocumentPage />,
  },
];

export const representativeRegisterRoute: RoutePathsType = [
  {
    path: routerPath.register_representative,
    name: 'Регистрация представителя издательств',
    Component: <RegisterRepresentativePage />,
  },
  {
    path: routerPath.registeredRepresentative,
    name: 'Регистрация представителя издательств',
    Component: <RepresentativeRegisteredPage />,
  },
];
